import { useOpenClose } from 'core/hooks/useOpenClose';
import { BorderedContainer } from '../../../common/BorderedContainer';
import { SectionTitle } from '../../../common/SectionTitle';
import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type PhotoProps = {
  /** 写真。*/
  images: IncidentDetailPatient['imageIds'];
};

export const Photo = ({ images }: PhotoProps) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="写真" />
        <div className="flex flex-wrap gap-[16px]">
          {images.map(image => (
            <ImageCard key={image.id} src={image.preSignedUrl ?? ''} />
          ))}
        </div>
      </div>
    </BorderedContainer>
  );
};

type ImageCardProps = {
  /** 画像パス。 */
  src: string;
};

const ImageCard = ({ src }: ImageCardProps) => {
  const { isOpen, handleOpen, handleClose } = useOpenClose();

  return (
    <>
      <button onClick={handleOpen}>
        <div className="border border-outline rounded-[16px] overflow-hidden w-[152px] h-[152px] flex items-center justify-center bg-white">
          <img src={src} alt={'alt'} className="object-cover w-full h-full" />
        </div>
      </button>
      {isOpen ? (
        <>
          <div className="fixed inset-0 bg-textPrimary bg-opacity-45 z-10" />
          <div className="top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-[1200px] w-full h-full p-[40px] absolute z-20">
            <div className="flex flex-col gap-[16px]">
              <button onClick={handleClose} className="ml-auto">
                <CloseIcon />
              </button>
              <div className="pb-[40px]">
                <img
                  src={src}
                  alt={'alt'}
                  className="object-cover w-full h-auto"
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      className="size-10"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18 18 6M6 6l12 12"
        stroke="#FDFDFD"
      />
    </svg>
  );
};
